import classNames from 'classnames';

import { useBrowserWidth, useIsMobile } from '../../hooks';
import { GoBackButton } from '..';

import styles from './ContainerBackButton.module.scss';

type ContainerBackButtonProps = {
  noMargin?: boolean;
  onBackBtnPress?: () => void;
};

const ContainerBackButton = (props: ContainerBackButtonProps) => {
  const { noMargin, onBackBtnPress } = props;
  const { isMobile } = useIsMobile();
  const { browserWidthSize } = useBrowserWidth();
  return (
    <>
      { browserWidthSize <= 989 && !isMobile && (
      <div className={classNames(styles.goBackBtn, { [styles.noMargin]: noMargin })}>
        <GoBackButton onBackBtnPress={onBackBtnPress} />
      </div>
      )}
    </>
  );
};

export default ContainerBackButton;
